import { ProductTenor } from '@protos/product';
import { OtcExchange } from '@protos/v2/otcQuote';
import { createContext, ReactNode, useCallback, useContext, useMemo, useState } from 'react';

type TradingTenorState = {
  widgetTenorMap: Record<
    string,
    { isSpread: boolean; exchange: OtcExchange; tenorsUsed: (ProductTenor | { left: ProductTenor; right: ProductTenor })[]; product: string }
  >;
  setWidgetTenorMap: React.Dispatch<
    React.SetStateAction<
      Record<
        string,
        {
          isSpread: boolean;
          exchange: OtcExchange;
          tenorsUsed: (ProductTenor | { left: ProductTenor; right: ProductTenor })[];
          product: string;
        }
      >
    >
  >;
  getAllUsedTenors: (
    id: string,
    isSpread: boolean,
    currentExchange: OtcExchange,
    currentProduct: string
  ) => (ProductTenor | { left: ProductTenor; right: ProductTenor })[];
};

type Props = {
  children: ReactNode;
};

const TradingTenorContext = createContext<TradingTenorState | undefined>(undefined);
TradingTenorContext.displayName = 'TradingTenorContext';

export default function TradingTenorProvider({ ...otherProps }: Props) {
  const [widgetTenorMap, setWidgetTenorMap] = useState<
    Record<
      string,
      { isSpread: boolean; exchange: OtcExchange; tenorsUsed: (ProductTenor | { left: ProductTenor; right: ProductTenor })[]; product: string }
    >
  >({});

  // FLUX-334 - quick fix to stop trading widgets restricting which tenors are available
  const getAllUsedTenors = () => [];

  const value: TradingTenorState = useMemo(
    () => ({
      widgetTenorMap,
      setWidgetTenorMap,
      getAllUsedTenors,
    }),
    [widgetTenorMap, getAllUsedTenors]
  );

  return <TradingTenorContext.Provider value={value} {...otherProps} />;
}

export function useTradingTenorContext(): TradingTenorState {
  const context = useContext(TradingTenorContext);

  if (!context) {
    throw new Error('useTradingTenorContext must be used within a TradingTenorProvider');
  }

  return context;
}
